import { jsx as e, Fragment as S, jsxs as g } from "react/jsx-runtime";
import { Table as _, TableBody as k, TableRow as h, TableCell as l, Skeleton as y, TableContainer as j, Paper as R, TableHead as w } from "@mui/material";
import '../../assets/table.css';const B = "_tableContainer_14h2x_1", K = "_tableElement_14h2x_6", O = "_stickyColumn_14h2x_11", P = "_stickyHeader_14h2x_18", z = "_stickyHeaderColumns_14h2x_27", a = {
  tableContainer: B,
  tableElement: K,
  stickyColumn: O,
  stickyHeader: P,
  stickyHeaderColumns: z
}, q = (v) => {
  const { columns: c, rows: m, isPending: H, numSticky: u = 0, sx: N, className: b, size: C = "medium", rowKey: o, selectedRowKey: x } = v;
  let p = 0;
  const T = (t) => {
    let n = "";
    return typeof t == "string" ? n = t : n = t.header, p != u ? (p++, [/* @__PURE__ */ e(l, { className: a.stickyHeader, children: n })]) : [/* @__PURE__ */ e(l, { className: a.stickyHeaderColumns, children: n })];
  }, E = (t, n, d) => {
    if (c.length > 0 && typeof c[0] == "string") {
      let r = 0;
      return /* @__PURE__ */ e(h, { selected: d, children: Object.keys(t).map((s) => {
        var i = {};
        return n && (i = { borderBottom: 0 }), r != u ? (r++, [/* @__PURE__ */ e(l, { className: a.stickyColumn, sx: i, children: t[s] })]) : [/* @__PURE__ */ e(l, { sx: i, children: t[s] })];
      }) });
    } else
      return /* @__PURE__ */ e(h, { selected: d, children: c.map((r, s) => {
        const { id: i } = r;
        return /* @__PURE__ */ e(
          l,
          {
            className: s < u ? a.stickyColumn : void 0,
            sx: s === c.length ? { borderBottom: 0 } : void 0,
            children: t[i]
          },
          i
        );
      }) });
  };
  if (H)
    return /* @__PURE__ */ e(S, { children: Array.from({ length: 8 }).map((t, n) => /* @__PURE__ */ e(_, { className: a.tableElement, size: C, children: /* @__PURE__ */ e(k, { children: /* @__PURE__ */ g(h, { children: [
      /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(y, { variant: "rectangular", sx: { width: "100%", height: "30px" } }) }),
      /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(y, { variant: "rectangular", sx: { width: "100%", height: "30px" } }) }),
      /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(y, { variant: "rectangular", sx: { width: "100%", height: "30px" } }) })
    ] }, n) }) })) });
  const f = [a.tableContainer];
  return b && f.push(b), /* @__PURE__ */ e(j, { className: f.join(" "), component: R, elevation: 3, sx: N, children: /* @__PURE__ */ g(_, { className: a.tableElement, size: C, children: [
    /* @__PURE__ */ e(w, { children: /* @__PURE__ */ e(h, { children: c.map((t) => T(t)) }) }),
    /* @__PURE__ */ e(k, { children: m.map((t, n) => {
      var d = m.indexOf(t) == m.length - 1;
      let r = !1;
      if (x !== void 0 && o !== void 0) {
        const s = typeof o == "function" ? o(t, n) : t[o];
        r = String(s) === String(x);
      }
      return E(t, d, r);
    }) })
  ] }) });
};
export {
  q as TableComponent
};
//# sourceMappingURL=table.js.map
